import { render, staticRenderFns } from "./MailTemplateTable.vue?vue&type=template&id=37c5b608&scoped=true"
import script from "./MailTemplateTable.vue?vue&type=script&lang=ts"
export * from "./MailTemplateTable.vue?vue&type=script&lang=ts"
import style0 from "./MailTemplateTable.vue?vue&type=style&index=0&id=37c5b608&prod&lang=css"
import style1 from "./MailTemplateTable.vue?vue&type=style&index=1&id=37c5b608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c5b608",
  null
  
)

export default component.exports